<template>
  <div
    class="kt-wizard-v2__content wizard-ctner"
    data-ktwizard-type="step-content"
    data-ktwizard-state="current"
  >
    <form class="kt-form">
      <div class="kt-heading kt-heading--md">
        {{ heading }}
      </div>
      <slot name="content"> </slot>
      <hr v-if="!hideFooter" />
      <div v-if="!hideFooter" class="kt-form__actions">
        <button
          @click.prevent="reset"
          class="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u setting-cancel-btn"
        >
          Cancel
        </button>
        <button
          @click.prevent="submit"
          class="btn btn-primary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u setting-save-btn"
        >
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: { heading: String, hideFooter: Boolean },
  methods: {
    submit() {
      this.$emit("submit");
    },
    reset() {
      this.$emit("reset");
    }
  }
};
</script>

<style>
.kt-form {
  padding: 0 !important;
}
.kt-wizard-v2__content {
  padding: 4rem 6rem 6rem;
}
.kt-form__actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  /* width: 75%; */
}

.setting-cancel-btn {
  margin-right: 1rem;
}

@media screen and (max-width: 550px) {
  .wizard-ctner {
    padding: 4rem 1rem 1rem;
  }
}
</style>
